import { ReactElement } from "react";
import ReportingDataviz from "../ReportingDataViz";
import { PageContainer } from "../../components/Common";

const Dashboard = (): ReactElement => {
  return (
    <PageContainer isDatavizPage={true}>
      <ReportingDataviz labelReport="Home" />
    </PageContainer>
  );
};

export default Dashboard;